import { render, staticRenderFns } from "./StockFilterDialog.vue?vue&type=template&id=53b44ba3"
import script from "./StockFilterDialog.vue?vue&type=script&lang=js"
export * from "./StockFilterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports